import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';
import { isNotFoundError } from '@app-velocity/common';

export const useGetRemarksQuery = (
  appraisalId?: string,
  workspaceId?: string,
  mode?: 'authorized' | 'guest',
  refetch = false
) => {
  const { appraisals } = useAvApi();

  const data = useQuery({
    enabled: !!appraisalId && !!workspaceId && !!mode,
    queryKey: ['appraisal-remarks', workspaceId, appraisalId, mode],
    queryFn: async () => {
      if (!appraisalId || !workspaceId) return;

      if (mode === 'authorized') {
        const data = await appraisals.getAppraisalsByIdAndProjectId({
          id: appraisalId,
          projectId: workspaceId,
        });

        return data.data;
      }

      if (mode === 'guest') {
        const data = await appraisals.getGuestAppraisalsById({
          id: appraisalId,
        });

        return data.data;
      }
    },
    refetchInterval: (query) => {
      if (!refetch) return false;

      if (isNotFoundError(query.state.error)) {
        return 3000;
      }

      if (query.state.data?.appraisalStatus === 'IN_PROGRESS') {
        return 3000;
      }

      return false;
    },
    retry: (failureCount, error) =>
      !isNotFoundError(error) && failureCount < 3,
  });

  return data;
};
